import React, { useState, useEffect } from 'react';
import wallOfLoveHeroLoop from 'assets/images/wall-of-love-hero-loop.mp4';

const HeroLove = ({ scrollToSection, isReviewLoaded }) => {
  const [ isImgLoading, setIsImgLoading ] = useState(false);
  const [ awaitImgLoad, setAwaitImgLoad ] = useState(false);

  useEffect(() => {
    if (!isImgLoading) return;
    const timer = setTimeout(() => {
      setAwaitImgLoad(true);
    }, 500);

    // eslint-disable-next-line consistent-return
    return () => clearTimeout(timer);
  }, [ isImgLoading ]);

  const handleVideoLoaded = () => {
    setIsImgLoading(true);
  };

  return (
    <section className='hero hero--love'>
      <div className='hero__inner img-relative' style={{ aspectRatio: !awaitImgLoad ? `${1640 / 922}` : 'auto' }}>
        {!awaitImgLoad && <div className='image-placeholder' style={{ aspectRatio: `${1640 / 922}` }} />}
      <h1 className='hero__wall-of-love-title'>
      The Wall of Love: What Mila Owners Are Saying


      </h1>

        <video
          className={`hero__video ${!awaitImgLoad ? 'img-absolute' : ''}`}
          src={wallOfLoveHeroLoop}
          type='video/mp4'
          playsInline
          webkit-playsinline='true'
          autoPlay
          muted
          loop
          onCanPlayThrough={handleVideoLoaded}
        />
        {isReviewLoaded
          && (
            <div className='hero__scroll-to'>
              <button type='button' className='scroll-to-section scroll-to-section--hero' onClick={() => scrollToSection()} aria-label='scroll to top'>
                <span className='screen-reader-text'>scroll to top</span>
                <svg className='icon icon-arrow-dropdown'>
                  <use xlinkHref='#icon-arrow-dropdown' />
                </svg>
              </button>
            </div>
          )}
      </div>
    </section>
  );
};

export default HeroLove;
